import { PageThemeTypeEnum } from '@/enums/pageThemeType';
import { HomeSceneTypeEnum } from '@/pages/home/types';
import platform from '@/shared/utils/platform';
import { getHomeActivityModulesConfig } from '@/shared/activity-undertake';
import { HOME_CUSTOM_CONFIG, HOME_PLATFORM_CONFIG } from './local.config';
import { ConfigNodeTypeEnum, HomeCustomConfig } from './types';

/** 获取(映射)首页场景类型 */
export const getSceneTypeMapping = (
  isPocketMoneyLoan: boolean,
  isMiddleIncomeShow: boolean,
): HomeSceneTypeEnum | undefined => {
  if (isPocketMoneyLoan) {
    return HomeSceneTypeEnum.POCKET_MONEY;
  }
  if (isMiddleIncomeShow) {
    return HomeSceneTypeEnum.MIDDLEINCOME;
  }
  return undefined;
};

/**
 * 若是定制化模式(如：送话费营销活动)，则取merge后的配置
 * 定制化配置覆盖默认配置
 */
export const getHomeCustomConfig = (
  pageTheme?: PageThemeTypeEnum,
  sceneType?: HomeSceneTypeEnum,
  isUseWebp = false,
): HomeCustomConfig => {
  const platformConfig = (HOME_PLATFORM_CONFIG[platform.name] || {});

  const mergedConfig = {
    ...HOME_CUSTOM_CONFIG.default,
    ...(pageTheme ? HOME_CUSTOM_CONFIG[pageTheme as keyof typeof HOME_CUSTOM_CONFIG] : {}),
    /** 平台的定制化配置(如：微信小程序) */
    ...platformConfig,
    /** wisdom活动配置(优先级次之)，覆盖以上配置 */
    ...getHomeActivityModulesConfig(),
    /** 业务定制化配置(优先级最高)，覆盖以上配置 */
    ...(sceneType ? HOME_CUSTOM_CONFIG[sceneType] : {}),
  };

  /** 若可使用webp，则将图片节点default设置为webp格式得图片url */
  if (isUseWebp) {
    const { navbar, header } = mergedConfig.themeConfig;

    if (navbar.backgroundImage && navbar.backgroundImage.webp) {
      navbar.backgroundImage.default = navbar.backgroundImage.webp;
    }

    if (header.backgroundImage && header.backgroundImage.webp) {
      header.backgroundImage.default = header.backgroundImage.webp;
    }
  }

  return mergedConfig as HomeCustomConfig;
};
